(function() {
    const elements = document.querySelectorAll('.c24Preisalarm');

    for (let i = 0; i < elements.length; i++) {
        new window.Vue({
            el: '#' + elements[i].id,
            data: {
                sMail: '',
                sFormTarget: '',
                bSubmitted: false,
                bIsError: false,
                oErrors: {
                    'notValid': 'Keine gültige E-Mail-Adresse.',
                    'empty': 'Formular nicht ausgefüllt.',
                    'generic': 'Etwas ist schiefgelaufen. Probiere es später erneut.',
                },
                oSubmitFeedback: {
                    'success': 'Vielen Dank. Wir erinnern Sie.',
                    'error': 'Etwas ist schiefgelaufen. Probiere es später erneut.',
                },
                sErrorMsg: '',
            },
            methods: {
                fnSubmit: function(e) {
                    this.bIsError = false;

                    this.sFormTarget = e.target.action;

                    this.sMail = this.sMail.replace(/ /g,'');

                    if (this.sMail.length < 1) {
                        this.fnThrowError('empty');

                        return false;
                    }

                    if (!this.fnValidateEmail(this.sMail)) {
                        this.fnThrowError('notValid');

                        return false;
                    }

                    this.fnSendXmlRequest(this.sMail);
                },
                fnValidateEmail: function (sInput) {
                    const sRegEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                    return sRegEx.test(sInput);
                },
                fnSendXmlRequest: function (sMail) {
                    const oRequest = new XMLHttpRequest();
                    const oFormData = new FormData();
                    let aResponse;

                    oFormData.append('mail', sMail);
                    oRequest.open('POST', this.sFormTarget, true);

                    oRequest.send(oFormData);

                    oRequest.onerror = function() {
                        this.fnThrowError();

                        return false;
                    }.bind(this);

                    oRequest.onreadystatechange = function() {
                        if (oRequest.readyState === 4) {
                            this.bSubmitted = true;

                            if (oRequest.status !== 200) {
                                this.fnThrowError();

                                return false;
                            }

                            if (oRequest.response) {
                                try {
                                    aResponse = JSON.parse(oRequest.response);

                                    if (aResponse.status !== 'success') {
                                        this.fnThrowError(aResponse.status);

                                        return false;
                                    }
                                } catch (exception) {
                                    this.fnThrowError();

                                    return false;
                                }
                            }

                            return true;
                        }
                    }.bind(this);
                },
                fnThrowError: function (sType) {
                    if (this.bIsError) {
                        return;
                    }

                    sType = (sType) ? sType : 'generic';

                    this.sErrorMsg = (this.oErrors[sType]) ? this.oErrors[sType] : this.oErrors.generic;

                    this.bIsError = true;
                },
            },
            computed: {
                sMailComputed: {
                    get: function () {
                        return this.sMail;
                    },
                    set: function (sInput) {
                        this.sMail = sInput.replace(/ /g,'');
                    },
                },
            },
        });
    }
})();
